import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/faqs`;
const token = localStorage.getItem("token");

/// GET
// Récupérer toutes les FAQs
export const getAllFaqs = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allFaqs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data) {
      console.log("Réponse API FAQ :", response.data);
      return response.data;
    } else {
      console.error("Les données FAQ de l'API sont vides ou non définies.");
      return [];
    }
  } catch (error) {
    console.error("Erreur lors du chargement des FAQs :", error);
    return [];
  }
};

// Récupérer une FAQ par ID
export const getFaqById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/faqById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de la FAQ :", error);
  }
};

/// POST
// Ajouter une FAQ
export const addFaq = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/addFaq`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de la FAQ :", error);
  }
};

/// PUT
// Mettre à jour une FAQ
export const updateFaq = async (id, formData) => {
  try {
    const response = await axios.put(`${apiUrl}/updateFaq/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la FAQ :", error);
  }
};

/// DELETE
// Supprimer une FAQ
export const deleteFaq = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteFaq/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de la FAQ :", error);
  }
};

/// SEARCH
// Rechercher une FAQ par mots-clés
export const searchFaqs = async (query) => {
  try {
    const response = await axios.get(
      `${apiUrl}/search?q=${encodeURIComponent(query)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la recherche FAQ :", error);
    return [];
  }
};
